module.exports = __webpack_public_path__ + "static/offer-ipad-3659c187f9d4e1fe608a397542bd581c.png";